import { render, staticRenderFns } from "./BoletinPeriodoInem.vue?vue&type=template&id=2d70c650&scoped=true&"
import script from "./BoletinPeriodoInem.vue?vue&type=script&lang=js&"
export * from "./BoletinPeriodoInem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70c650",
  null
  
)

export default component.exports